<template>
  <gat-select
    :style="showSelect ? '' : 'display:none'"
    v-model="emailFrom"
    :label="label"
    :items="fromItems"
    :noflex="noFlex"
    :readonly="isReadonly"
    @item-selected="$emit('item-selected', $event)"
    :required="required" />
</template>

<script>
// import { apiGet } from '../store/api'
import { useApplicationStore } from '@/store/applicationStore';

export default {
  name: 'SelectEmailFrom',
  props: {
    value: String,
    startValue: {},
    agencyId: {
      type: Number,
    },
    label: {
      type: String,
      default: 'From',
    },
    noFlex: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    templateFrom: {
      type: Number,
      default: 0,
    },
    templateFromValue: {
      type: String,
      default: '',
    },
    required: Boolean,
  },
  components: {},
  setup() {
    const applicationStore = useApplicationStore();
    return {
      applicationStore,
    };
  },
  data() {
    return {
      emailFrom: undefined,
      fromItems: [],
    };
  },
  activated() {
    this.fromItems = [];
    this.getFromAddress();
    // if(Array.isArray(this.fromItems) && this.fromItems.length === 0){
    //     this.getFromAddress();
    // } else {
    //     this.emailFrom = this.fromItems[0].value;
    // }
  },
  mounted() {},

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.emailFrom = val;
      },
    },
    fromItems: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          if (this.startValue && !this.emailFrom) {
            this.emailFrom = this.startValue;
          } else {
            this.emailFrom = val[0].value;
          }
        }
      },
    },
    emailFrom(val) {
      this.$emit('input', val);
    },
  },

  computed: {
    isReadonly() {
      return this.readonly || (Array.isArray(this.fromItems) && this.fromItems.length === 1);
    },
    showSelect() {
      return true; // Array.isArray(this.fromItems) && this.fromItems.length >= 2;
    },
  },

  methods: {
    getFromAddress() {
      const result = [];

      const agency = this.applicationStore.getAgencySettings(this.agencyId);
      const { user, globalSettings } = this.applicationStore;
      const agencyName = globalSettings.SGL_WM_EMAIL_USE_PERSONAL_ON_AGENCY === 1 ? user.fullName : agency.AGENT;

      const agencyItem = {
        NAME: agencyName,
        EMAIL: agency.EMAIL,
        text:
          globalSettings.SGL_WM_EMAIL_USE_PERSONAL_ON_AGENCY === 1 ? `${agencyName} <${agency.EMAIL}>` : agency.EMAIL,
        value: agency.EMAIL,
      };

      const userItem = {
        NAME: user.fullName,
        EMAIL: user.email,
        text: `${user.fullName} <${user.email}>`,
        value: user.email,
      };

      let fromEmailTemplate = 0;
      if (Number.isFinite(this.templateFrom)) {
        fromEmailTemplate = this.templateFrom;
      }

      if (fromEmailTemplate === 0) {
        // Use global settings
        fromEmailTemplate = globalSettings.SGL_WM_EMAIL_FROM;
      }

      if (this.applicationStore.user.internal) {
        if (fromEmailTemplate === 1 /* Personal email only */) {
          result.push(userItem);
        } else if (fromEmailTemplate === 0 || fromEmailTemplate === 2 /* Agency email only */) {
          result.push(agencyItem);
        } else if (fromEmailTemplate === 3 /* Personal email and optional agency email */) {
          result.push(userItem);
          result.push(agencyItem);
        } else if (fromEmailTemplate === 4 /* Agency email and optional personal email */) {
          result.push(agencyItem);
          result.push(userItem);
        } else if (fromEmailTemplate === 5 && this.templateFromValue /* Email from template */) {
          const fromItem = {
            NAME: '',
            EMAIL: this.templateFromValue,
            text: `${this.templateFromValue}`,
            value: this.templateFromValue,
          };
          result.push(fromItem);
        } else {
          result.push(userItem);
        }
      } else if ([2, 3, 4].includes(fromEmailTemplate)) {
        result.push(agencyItem);
      }

      this.fromItems = result;
    },
  },
};
</script>

<style scoped></style>
